import { __assign, __read, __rest, __spread } from "tslib";
import React, { useCallback, useState } from 'react';
import { useThemeProps } from '../../../../foundation';
import { RcFormContext } from './FormContext';
var RcForm = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcForm' });
    var children = props.children, isSubmitting = props.isSubmitting, onBeforeSubmit = props.onBeforeSubmit, onValidateFailed = props.onValidateFailed, onSubmit = props.onSubmit, rest = __rest(props, ["children", "isSubmitting", "onBeforeSubmit", "onValidateFailed", "onSubmit"]);
    var _a = __read(useState(function () { return new Map(); }), 1), fieldManager = _a[0];
    var handleSubmit = useCallback(function (event) {
        event.preventDefault();
        if (isSubmitting)
            return;
        onBeforeSubmit && onBeforeSubmit();
        var validateMessages = __spread(fieldManager.values()).map(function (fieldInfo) { return fieldInfo.validate(); })
            .filter(function (msg) { return msg !== false; });
        if (validateMessages.length > 0) {
            onValidateFailed && onValidateFailed();
            return;
        }
        onSubmit && onSubmit(event);
    }, [isSubmitting, onBeforeSubmit, fieldManager, onSubmit, onValidateFailed]);
    return (React.createElement(RcFormContext.Provider, { value: fieldManager },
        React.createElement("form", __assign({ onSubmit: handleSubmit }, rest), children)));
};
export { RcForm };
